import { IParameter, TFunctionParamsNames } from "./types";

const mainHst = process.env.REACT_APP_HOST;

async function getResponse(res: Response) {
    // console.log(res);
    if (res.ok) {
        return res.json();
    } else {
        try {
            // Пробуем получить JSON-объект из ответа
            const errorData = await res.json();
            console.error('Ошибка:', errorData);
            return Promise.reject(
                `ошибка: ${res.status} - ${res.statusText} |  ${JSON.stringify(errorData)}`
            );
        } catch (error) {
            // Если JSON не удалось получить, возвращаем стандартную ошибку
            console.error('Ошибка при парсинге ответа:', error);
            return Promise.reject(
                `ошибка: ${res.status} - ${res.statusText}`
            );
        }
    }
}

function buildUrlWithQuery(urlString: string, paramsAndValue: { key: string, value: string | number }[]) {
    const url = new URL(urlString);
    const params = Object.keys(paramsAndValue);

    paramsAndValue.forEach((item: { key: string, value: string | number }) => {
        url.searchParams.append(item.key.toString(), item.value.toString());
    });
    return url;
}

interface FetchParams {
    host?: string;
    route?: string;
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
    body?: Record<string, any>;
    token?: string;
    headers?: Record<string, string>;
    contentType?: 'application/json' | 'multipart/form-data',
    formData?: FormData;
}

async function buildFetch({
    host = mainHst,
    route,
    method = 'POST',
    body,
    contentType = 'application/json',
    formData,
}: FetchParams) {

    let headers: Record<string, string> = {} = {
        //Authorization: `Bearer ${token}`,
    };
    if (contentType && contentType !== 'multipart/form-data') {
        headers['Content-Type'] = contentType;
    }

    let options: RequestInit = {
        method,
        headers,
    };
    if (body) {
        //@ts-ignore
        if (contentType === 'application/json') {
            options.body = JSON.stringify(body);
        }
    } else if (formData) {
        options.body = formData;
    }
    const url = route ? `${host}${route}` : `${host}`;
    return fetch(`${url}`, options).then((res) => getResponse(res));;
}

const createFormData = (
    data: { [key: string]: any },
) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value && value.uri && value.name && value.type) {
            const fileBlob = value.uri;
            const file = new File([fileBlob], value.name, { type: value.type });
            formData.append(key, file);
        } else {
            formData.append(key, value);
        }
    });

    return formData;
};

interface Parameter {
    name: string;
    value: number | string | null;
}

interface BuildRequestBodyParams {
    app_name?: string;
    city_id?: string;
    NCITY_ID?: string;
    client_version?: number;
    object_name?: TFunctionParamsNames;
    parameters?: Parameter[] | IParameter[];
    timezone?: string;
    username?: string;
}

interface RequestBody {
    data: {
        app_name: string;
        city_id: string;
        client_version: number;
        object_name: TFunctionParamsNames;
        parameters?: Parameter[] | IParameter[];
        timezone: string;
        username: string;
    }
}

const buildRequestBody = ({
    app_name = "com.ultrastar.svobltransport",
    city_id = "",
    NCITY_ID = "",
    client_version = 1,
    object_name = "GET_CITIES_JSON",
    parameters = [],
    timezone = "+05:00",
    username = "",
}: BuildRequestBodyParams): RequestBody => {
    console.log(object_name);
    return {
        data: {
            app_name,
            city_id: NCITY_ID ? NCITY_ID.toString() : city_id.toString(),
            client_version,
            object_name,
            parameters,
            timezone,
            username,
        }
    };
};


export {
    createFormData,
    getResponse,
    buildUrlWithQuery,
    buildFetch,
    buildRequestBody,
};
